module.exports = __webpack_public_path__ + "img/mexc-logo.ed303a3a.png";